import React from 'react';
import styled from 'styled-components';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {isMobileOnly} from 'react-device-detect';

const HeaderMenuBtnBlock = styled.div`
    display: inline-block;
    cursor: pointer;
    vertical-align: 3px;
    position: relative;
    z-index: 30;
`;

const HeaderMenuBtnSpanBlock = styled.span`
    display: block;
    width: ${isMobileOnly?'26px':'34px'};
    height: ${isMobileOnly?'2px':'4px'};
    opacity: ${props => props.opacity || '1'};
    margin-bottom: ${props => props.marginBottom || isMobileOnly?'6px':'8px'};
    ${isMobileOnly&&"margin-top: 6px"};
    background-color: #111;
    border-radius: 10px;
    -webkit-transition: ${props => props.transition};
    -ms-transform: ${props => props.transition};
    transform:  ${props => props.transition};
    -o-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
`;

const HeaderMenuBtn = ({ onClick }) => {

    var { openMenu } = useSelector(
        ({ headerReducer }) => ({
            openMenu: headerReducer.openMenu,
        })
    );

    useEffect(() => {
    }, [openMenu])

    const translateY = isMobileOnly?'8.3px':'12px'
    return (
        <HeaderMenuBtnBlock onClick={onClick}>
            <HeaderMenuBtnSpanBlock
                active={openMenu}
                transition={openMenu ? `translateY(${translateY}) rotate(45deg)` : "all 0.3s ease-in-out"}
            />
            <HeaderMenuBtnSpanBlock
                active={openMenu}
                opacity={openMenu ? '0' : '1'}
                transition={openMenu ? "translateX(10px)" : "all 0.3s ease-in-out"}
            />
            <HeaderMenuBtnSpanBlock
                active={openMenu} marginBottom="0px"
                transition={openMenu ? `translateY(-${translateY}) rotate(-45deg)` : "all 0.3s ease-in-out"}
            />
        </HeaderMenuBtnBlock>
    );
};

export default HeaderMenuBtn;
